import "./CustomForm.css";
import React, { createContext } from "react";
import PropTypes from "prop-types";
import FormError from "./FormError";
import classNames from "classnames";
import { observer } from "mobx-react";

const CustomFormContext = createContext({ form: {} });

@observer
class CustomForm extends React.Component {
    static propTypes = {
        onSubmit: PropTypes.func,
        form: PropTypes.object.isRequired,
        name: PropTypes.string,
        className: PropTypes.string,
        action: PropTypes.string,
        showFormLevelErrors: PropTypes.bool,
        autoComplete: PropTypes.string
    };

    static defaultProps = {
        onSubmit: (e) => e && e.preventDefault(),
        action: "/form/default",
        showFormLevelErrors: true
    };

    render() {
        return (
            <CustomFormContext.Provider value={{ form: this.props.form }}>
                <form method="POST" autoComplete={this.props.autoComplete} action={this.props.action} name={this.props.name} onSubmit={this.props.onSubmit} className={classNames(["custom-form", this.props.className])}>
                    {this.props.showFormLevelErrors && <FormError form={this.props.form} />}
                    {this.props.children}
                </form>
            </CustomFormContext.Provider>
        );
    }
}

export { CustomFormContext };
export default CustomForm;
